import '../App.css';

import { BunniesDatatable } from '../components/datatables/bunniesDatatable';
import TestInbreedingDialog from '../components/dialogs/testInbreedingDialog';

function Bunnies() {
    return (
        <div className='flex w-full items-center justify-center'>
            <div className='flex w-5/6 sm:w-3/4 flex-col py-6 gap-3'>
                <div className='grid grid-cols-1 lg:grid-cols-2 items-start lg:gap-6'>
                    <div>
                        <h1 className='font-medium text-2xl'>Kaninregister</h1>
                        <p className='text-muted-foreground text-sm'>Här visas samtliga kaniner i systemet.</p>
                    </div>
                    <div className='grid grid-cols-1 xl:grid-cols-4 gap-3 pt-3'>
                        <TestInbreedingDialog />
                    </div>
                </div>
                <BunniesDatatable />

            </div>
        </div>
    );
}

export default Bunnies;
